module.exports = __webpack_public_path__ + "static/media/fog.40336924.svg";